import { createRpcClientV2 } from 'rpc-client-utils';
import { getPortalGuidesRpc } from '../__generated__/chirp/com/hubspot/user/context/rpc/PlanProgressRpc';
import http from 'hub-http/clients/apiClient';
import { gql } from '@apollo/client';
const GET_OBJECT_PORTAL_ID = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"GetObjectPortalId\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"ListValue\",\"values\":[{\"kind\":\"StringValue\",\"value\":\"portal_id\",\"block\":false}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetObjectPortalId"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "properties"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "names"
              },
              value: {
                kind: "ListValue",
                values: [{
                  kind: "StringValue",
                  value: "portal_id",
                  block: false
                }]
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});

// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = async ({
  graphqlClient,
  dfcClient: __dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId
  }
}) => {
  try {
    var _objectResponse$data;
    if (!objectId || !objectTypeId) {
      return {
        portalGuides: [],
        error: 'Missing objectId or objectTypeId'
      };
    }

    // First, fetch the object to get its portal_id property
    const objectResponse = await graphqlClient.query({
      query: GET_OBJECT_PORTAL_ID,
      variables: {
        objectId: Number(objectId),
        objectTypeId: String(objectTypeId)
      }
    });
    const portalIdProperty = (_objectResponse$data = objectResponse.data) === null || _objectResponse$data === void 0 || (_objectResponse$data = _objectResponse$data.crmObject) === null || _objectResponse$data === void 0 || (_objectResponse$data = _objectResponse$data.properties) === null || _objectResponse$data === void 0 ? void 0 : _objectResponse$data.find(prop => prop.name === 'portal_id');
    if (!(portalIdProperty !== null && portalIdProperty !== void 0 && portalIdProperty.value)) {
      return {
        portalGuides: [],
        error: 'No portal_id found on object'
      };
    }
    const rpcClient = createRpcClientV2({
      hubHttpClient: http
    });
    const response = await rpcClient.call(getPortalGuidesRpc, {
      request: {
        targetPortalId: Number(portalIdProperty.value)
      }
    });
    return {
      portalGuides: response.portalGuides || [],
      targetPortalId: Number(portalIdProperty.value)
    };
  } catch (error) {
    return {
      portalGuides: [],
      error: error instanceof Error ? error.message : 'Unknown error occurred'
    };
  }
};